import { apiInstance } from "../../../util/api";
import * as ActionType from "./admin.type";
import { setToast } from "../../../util/toast";
import { signPermissions } from "../../../util/permissionIntegrity";
import { getAllLanguages } from "../language/language.action";

export const signupAdmin = (signup) => (dispatch) => {
  return apiInstance
    .post("admin/create", signup)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({ type: ActionType.SIGNUP_ADMIN });
        setToast("success", "Signup Successfully!");
        setTimeout(() => {
          window.location.href = "/admin-login";
        }, 3000);
        return true;
      } else {
        setToast("error", res.data.message);
        return false;
      }
    })
    .catch((error) => {
      // setToast("error", error.response?.data?.message || error.message);
      return false;
    });
};

export const updateCode = (signup) => (dispatch) => {
  apiInstance
    .patch("admin/updateCode", signup)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Purchase Code Update Successfully !");
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.response?.data?.message || error.message);
    });
};


export const loginAdmin = (login, navigate) => (dispatch) => {
  return apiInstance
    .post("admin/login", login)
    .then(async (res) => {
      if (res.data.status) {
        if (res.data.subAdmin) {
          dispatch({
            type: ActionType.LOGIN_STAFF,
            payload: {
              token: res.data.token,
              subAdmin: res.data.subAdmin,
            },
          });
          await signPermissions("staff", res.data.subAdmin.permissions || []);
        } else {
          dispatch({ type: ActionType.LOGIN_ADMIN, payload: res.data.token });
          await signPermissions("admin", []);
        }

        // Fetch languages after login to verify if any exist
        dispatch(getAllLanguages());

        setToast("success", res.data.message || "Login Successfully!");
        setTimeout(() => {
          navigate("/admin");
        }, 1500)
        return true;
      } else {
        setToast("error", res.data.message);
        return false;
      }
    })
    .catch((error) => {
      setToast("error", error.response?.data?.message || error.message);
      return false;
    });
};



// get profile
export const getProfile = () => (dispatch) => {
  const token = sessionStorage.getItem("token");
  if (!token) return; // stop call

  apiInstance
    .get("admin/profile", { skipLoader: true })
    .then((res) => {
      dispatch({ type: ActionType.PROFILE_ADMIN, payload: res.data.admin });
    })
    .catch((error) => {
      console.log("error", error);
    });
};

// Update Admin profile image

export const UpdateAdminImage = (formData) => (dispatch) => {
  apiInstance
    .patch("admin/updateImage", formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_IMAGE_PROFILE,
          payload: res.data.admin,
        });
        setToast("success", "Image Update Successfully");
      }
    })
    .catch((error) => {
      setToast("error", error.response?.data?.message || error.message);
    });
};

export const updateProfile = (profileData) => (dispatch) => {

  apiInstance
    .patch("admin/updateProfile", profileData)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({ type: ActionType.UPDATE_PROFILE, payload: res.data.admin });
        setToast("success", "Profile Update Successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch(({ response }) => {
      setToast("error", response?.data?.message || "Something went wrong!");
    });
};

export const ChangeAdminPassword = (password) => (dispatch) => {
  apiInstance
    .patch("admin/updatePassword", password)
    .then((res) => {
      if (res.data.status === true) {
        setToast("success", "Your Password Changed Successfully !");
        dispatch({ type: ActionType.LOGOUT_ADMIN });
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.message);
    });
};

export const forgotPassword = (data) => (dispatch) => {
  apiInstance.post("admin/forgotPassword", data).then((res) => {
    if (res.data.status === true) {
      setToast("success", "Email Send Successfully !");
    } else {
      setToast("error", res.data.message);
    }
  });
};

export const resetPassword = (adminId, data) => (dispatch) => {
  apiInstance
    .post(`admin/setPassword?adminId=${adminId}`, data)
    .then((res) => {
      if (res.data.status === true) {
        setToast("success", "Password Changed Successfully !");
        setTimeout(() => {
          dispatch({ type: ActionType.LOGOUT_ADMIN });
          window.location.href = "/";
        }, 100);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.message);
    });
};
